import React from 'react';
import t from 'prop-types';
import { Icon } from './Icon';
import classNames from 'classnames';

export const Alert = ({
  color = 'warning',
  className,
  bar = false,
  icon,
  toggle,
  actions,
  children,
}) => {
  return (
    <div
      role="alert"
      className={classNames(
        `alert alert-flex alert-${color}`,
        { 'alert-bar': bar, 'alert-dismissible': typeof toggle === 'function' },
        className,
      )}
    >
      {icon &&
        (typeof icon === 'string' ? (
          <Icon name={icon} />
        ) : (
          <div className="alert-icon">{icon}</div>
        ))}
      <div className="alert-body">{children}</div>
      {actions && <div className="alert-actions">{actions}</div>}
      {toggle && (
        <button
          type="button"
          className={`btn btn-sm btn-link-${color} alert-close`}
          onClick={toggle}
          aria-label="Close Alert"
          title="Close Alert"
        >
          <Icon name="x" />
        </button>
      )}
    </div>
  );
};

Alert.propTypes = {
  /** Theme color of the alert */
  color: t.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
  ]),
  /** Additional classNames to add to the alert element. */
  className: t.string,
  /** Flag that determines the display of a left side border. */
  bar: t.bool,
  /** Name of icon or JSX content to render in the top left corner. */
  icon: t.node,
  /** Function to close the alert. */
  toggle: t.func,
  /** JSX content to render in the bottom right corner. */
  actions: t.node,
  /** JSX content to render in the body of the alert. */
  children: t.node,
};
